import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { uploadAvatar, userInfo } from '@blade-sxp/account/api/setting';
import { AccountModule } from '@blade-sxp/account/store/account';
import EncryptInput from '@blade/common/components/encrypt-input.vue';
import InvisibleNumber from '@blade/common/components/invisible-number.vue';
import BlurPicture from '@blade/common/components/blur-picture/index.vue';
let default_1 = class extends Vue {
    userName = '';
    email = '';
    state = '';
    Account = '';
    actionUrl = '';
    imageUrl = '';
    restaurants = this.loadAll();
    timeout = 0;
    phoneNum = '';
    phoneReg = /^(\+\d{1,3})?(-)?(\d{1,50})$/;
    // private emailReg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
    privacyMode = localStorage.getItem('privacyMode') || 'false';
    roleType = '';
    querySearchAsync(queryString, cb) {
        let restaurants = this.restaurants;
        let results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants;
        window.clearTimeout(this.timeout);
        this.timeout = window.setTimeout(() => {
            cb(results);
        }, 3000 * Math.random());
    }
    createStateFilter(queryString) {
        return (state) => {
            return state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
        };
    }
    handleSelect(item) {
        // console.log(item);
    }
    // handleAvatarSuccess(res: any, file: any) {
    //   this.imageUrl = URL.createObjectURL(file.raw);
    // }
    beforeAvatarUpload(file) {
        //   const isJPG = file.type === 'image/jpeg' || 'image/jpeg' || 'image/png';
        //   const isLt2M = file.size / 1024 / 1024 < 2;
        //   if (!isJPG) {
        //     this.$message.error('上传头像图片只能是 JPG 格式!');
        //   }
        //   if (!isLt2M) {
        //     this.$message.error('上传头像图片大小不能超过 2MB!');
        //   }
        //   return isJPG && isLt2M;
    }
    loadAll() {
        return [
            { value: '三全鲜食（北新泾店）', address: '长宁区新渔路144号' },
            {
                value: 'Hot honey 首尔炸鸡（仙霞路）',
                address: '上海市长宁区淞虹路661号',
            },
        ];
    }
    getUserMsg() {
        AccountModule.getUserInfo()
            .then((data) => {
            this.Account = data.user_name;
            this.userName = data.real_name;
            this.email = data.email;
            this.phoneNum = data.phone_number;
            this.roleType = data?.role_type;
            if (data.avatar) {
                // this.imageUrl = 'data:image/png;base64,' + data.avatar;
                this.imageUrl = data.avatar;
            }
        })
            .catch((err) => {
            this.$message({
                message: err,
                type: 'error',
            });
        });
    }
    mounted() {
        this.getUserMsg();
    }
    handleAvatarSuccess(file) {
        let _this = this;
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function (e) {
            // 图片base64化
            let newUrl = this.result; // 图片路径
            // console.log(newUrl);
            _this.imageUrl = newUrl;
            // (_this.form as any).image = newUrl;
        };
        return false;
    }
    uploadFile(pramas) {
        let _file = pramas.file;
        let formData = new FormData();
        formData.append('file', _file);
        console.log(_file);
        uploadAvatar(formData).then((res) => {
            console.log(res);
        });
    }
    updateUser() {
        let avatar = '';
        if (this.imageUrl) {
            avatar = this.imageUrl;
        }
        let data = {
            avatar: avatar,
            phone: this.phoneNum,
            real_name: this.userName,
        };
        userInfo(data)
            .then((res) => {
            this.$message({
                message: this.$t('updataSuccess').toString(),
                type: 'success',
            });
        })
            .catch((err) => {
            this.$message({
                message: err,
                type: 'error',
            });
        });
    }
    save() {
        let _this = this;
        // 电话号码 管理员必填 非管理员不用必填
        if (_this.roleType === 'TENANT_ADMIN') {
            if (!_this.phoneNum.trim()) {
                return _this.$message.error(this.$t('enetrPhoneNum').toString());
            }
            if (!_this.phoneReg.test(_this.phoneNum)) {
                return _this.$message.error(_this.$t('Phoneincorrect').toString());
            }
        }
        else {
            if (_this.phoneNum !== '' && !_this.phoneReg.test(_this.phoneNum)) {
                return _this.$message.error(_this.$t('Phoneincorrect').toString());
            }
        }
        this.updateUser();
    }
};
default_1 = __decorate([
    Component({
        name: 'record',
        components: { EncryptInput, InvisibleNumber, BlurPicture },
        i18n: {
            messages: {
                'en-us': {
                    basicSettings: 'Basic Settings',
                    account: 'Account',
                    name: 'Name',
                    phoneNum: 'Phone Number',
                    email: 'Email',
                    UpdateInformation: 'Update Information',
                    Clickupload: 'Click Upload',
                    pleaseEnter: 'Please enter',
                    enterName: 'Please enter your name',
                    enetrPhoneNum: 'Please enter your phone number',
                    Phoneincorrect: 'Phone number format is incorrect',
                    enterEmail: 'Please enter your eamil',
                    emailIncorrect: 'Email format is incorrect',
                    updataSuccess: 'Update information successfully',
                },
                zh: {
                    basicSettings: '基本设置',
                    account: '账户',
                    name: '姓名',
                    phoneNum: '手机号',
                    email: '邮箱',
                    UpdateInformation: '更新基本信息',
                    Clickupload: '点击上传',
                    pleaseEnter: '请输入',
                    enterName: '请输入姓名',
                    enetrPhoneNum: '请输入您的手机号',
                    Phoneincorrect: '手机号格式不正确',
                    enterEmail: '请输入您的邮箱',
                    emailIncorrect: '邮箱格式不正确',
                    updataSuccess: '更新信息成功',
                },
            },
        },
    })
], default_1);
export default default_1;
